/**
 * Drops tooltip field keys whose shapefile is not in the selected project's
 * tree (EVA-126).
 *
 * The persisted tooltip field list is a global user setting storing raw
 * property strings, so it carries `Shapefile_{projectId}_{shapefileId}_
 * {btoa(column)}` keys into every project - including ones whose shapefile was
 * deleted, and ones picked in a different project. Sending such a key on
 * returns a value with no name to put against it and no polygon context, and
 * the tooltip rendered a junk row - so the key is dropped before it reaches
 * the request.
 *
 * `isAbsentShapefileField` is expected to be conservative about evidence; see
 * useIsShapefileFieldAbsentFromProject. Anything it declines to judge (no tree
 * loaded yet) is kept, so an unresolved-for-now field still gets requested as
 * before.
 */
export const withoutAbsentShapefileFields = (
  fields: Maybe<string[]>,
  isAbsentShapefileField: (property: string) => boolean
): string[] => (fields ?? []).filter((field) => !isAbsentShapefileField(field));
